<template>
    <div class="item" :class="{'err': err, 'is-advanced': location.isSelfBuy || location.isInsulation || (location.vat && location.vat.length)}" @click.stop="onClick" :style="ColorStyle">
        <div class="title" :class="placeholderClass">
            <div class="left">
                <img v-if="isLast" src="@/assets/img/flag.svg">
                {{ title }} <span v-show="tag" :style="{'color': tagColor}">{{ tag }}</span>
            </div>
            <div class="right">
                <div v-show="location.isRoundTrip" class="round-trip">來回件</div>
            </div>
        </div>
        <div class="content">
            <div class="address" :class="placeholderClass">
                {{ fullAddress }}
            </div>
            <div class="button">
                <img v-if="canDelete" @click.stop="onDelete" src="@/assets/img/trash.svg">
                <img v-else src="@/assets/img/next-gray.png">
            </div>
        </div>
        <div class="contact" v-if="showContact || location.name || location.phone">
            <div class="name">
                聯絡人 {{ location.name || ''}}
            </div>
            <div class="phone">
                聯絡電話 {{ location.phone || ''}}
            </div>
        </div>
        <div class="note" v-show="location.note">
            <div class="icon">
                <img src="@/assets/img/enter.svg">
            </div>
            <div class="content">{{ location.note }}</div>
        </div>
        <div v-show="location.shop_id">
            <div class="products">
                <div v-for="(product, index) in location.products" :key="index" @click.stop="openProduct(index, product)">
                    <div class="divider" v-show="index > 0"/>
                    <div class="product" >
                        <div class="product-content">
                            <div class="product-title">
                                <span>x {{ product.count }}</span>{{ product.name }}
                            </div>
                            <div class="product-info">
                                {{ product.options | OptionsToString }}
                            </div>
                        </div>
                        <div class="product-price">
                            $ {{ product.is_elastic ? '依店內價格' : product.sumPrice * product.count }}
                        </div>
                    </div>
                    <div class="product-note" v-show="product.note">
                        <div class="product-icon">
                            <img src="@/assets/img/enter.svg">
                        </div>
                        <div class="product-content">{{ product.note }}</div>
                    </div>
                </div>
            </div>
            <div class="divider"/>
            <div class="price">
                此地點總費用 <span>$ {{ totalPrice }}</span>
            </div>
        </div>
        <div v-show="!location.shop_id && type !== 'last' && location.expectedPrice">
            <div class="divider"/>
            <div class="expected">
                <div class="label">
                    此地點<span>預計代付</span>
                </div>
                <div class="price">
                    ＄ {{ location.expectedPrice || '0' }}
                </div>
            </div>
        </div>
        <photo-uploader v-show="(location.photos || []).length" :value="location.photos || []" :is-preview-mode="true" :group-id="$vnode.key" class="photo-preview"/>
        <div class="advanced" v-show="location.isSelfBuy || location.isInsulation || (location.vat && location.vat.length)">
            <div class="advanced-item" v-show="location.isSelfBuy">
                <img src="@/assets/img/ordered-green.svg">
                已訂購
            </div>
            <div class="advanced-item" v-show="location.isInsulation">
                <img src="@/assets/img/insulation-green.svg">
                需保溫
            </div>
            <div class="advanced-item" v-show="location.vat && location.vat.length">
                <img src="@/assets/img/vat-green.svg">
                統編 {{ location.vat }}
            </div>
        </div>
        <div v-show="err">
            <div class="line"></div>
            <span class="err-msg">
                {{ err }}
            </span>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import PhotoUploader from "./PhotoUploader";

    export default {
        name: 'TaskItem',
        components: {
            'photo-uploader': PhotoUploader,
        },
        props: {
            title: {
                default: '',
            },
            location: {
                default: Object,
                required: true,
            },
            showContact: {
                default: false,
            },
            canDelete: {
                default: false,
            },
            type: {
                default: 'shop',
                required: true,
            },
            err: {
                default: '',
            },
            tag: {
                default: '',
            },
            tagColor: {
                default: '#339933',
            },
            placeholderText: {
                default: '填寫店家名稱或地址',
            },
            isLast: {
                default: false,
            }
        },
        computed: {
            ColorStyle() {
                if (! this.tag) {
                    return {};
                }

                return {
                    'border': '0.5px solid ' + this.tagColor,
                }
            },
            placeholderClass() {
                return {
                    placeholder: this.fullAddress === this.placeholderText,
                }
            },
            fullAddress() {
                if (this.location.alias) {
                    return this.location.alias;
                }

                let address = this.location.city + this.location.district + this.location.road;
                if (address) {
                    return address;
                }

                return this.placeholderText;
            },
            price() {
                if (!this.location.products) {
                    return 0;
                }

                return this.location.products.filter(product => !product.is_elastic).reduce((amount, product) => amount + (product.sumPrice * product.count), 0);
            },
            totalPrice() {
                return this.price + parseInt(this.location.expectedPrice || '0');
            }
        },
        methods: {
            onDelete() {
                this.$emit('onDelete', this.$vnode.key);
                this.deleteCartLocationByKey(this.$vnode.key);
            },
            onClick() {
                if (this.canDelete) {
                    return;
                }

                if (this.location.shop_id) {
                    return this.$router.push({
                        name: 'shop',
                        params: {
                            id: this.location.shop_id,
                        }
                    });
                }

                let index = this.$vnode.key;
                if (index === 'new') {
                    this.$router.push({
                        name: 'task',
                        params: {
                            type: this.type,
                            title: this.title,
                        }
                    });

                    return ;
                }

                this.$router.push({
                    name: 'task',
                    params: {
                        type: this.type,
                        id: index,
                        title: this.title,
                    }
                });
            },
            openProduct(index, product) {
                this.$emit('openProduct', {
                    key: this.$vnode.key,
                    index: index,
                    product: product,
                });
            },
            ...mapActions(['deleteCartLocationByKey'])
        },
        filters: {
            OptionsToString(options) {
                return options.map(option => option.name).join(', ');
            }
        }
    };
</script>

<style lang="scss" scoped>
    .placeholder {
        color: rgba(120,120,120,1);
    }

    .item {
        border: none;
        border-radius: 5px;
        background-color: rgba(255,255,255,1);
        box-shadow: 0 2px 8px 0 rgba(51,153,51,0.35);
        text-align: left;
        margin: 10px 15px;
        padding: 10px;
        position: relative;

        &.is-advanced {
            margin: 20px 15px;
        }

        .expected {
            display: flex;
            justify-content: center;
            color: #4A4A4A;
            font-size: 13px;
            font-weight: 500;

            span {
                color: #9B9B9B;
            }

            .price {
                color: #9B9B9B;
                font-size: 16px;
                font-weight: 500;
                margin-left: 10px;
            }
        }

        .photo-preview {
            margin-top: 5px;
        }

        .err-msg {
            position: absolute;
            color: rgba(244,67,54,1);
            font-size: 12px;
            font-weight: 500;
            line-height: 17px;
            bottom: -8px;
        }

        .line {
            border: solid 2px white;
            position: absolute;
            width: 63px;
            bottom: -2px;
            left: 6px;
        }

        &.err {
            border: 2px solid rgba(255,153,153,1) !important;
            box-shadow: 0 2px 8px 0 rgba(255,153,153,0.35) !important;
        }

        .title {
            font-size: 12px;
            line-height: 17px;
            color: #787878;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .right {
                .round-trip {
                    background-color: #4A4A4A;
                    color: white;
                    padding: 2px 10px;
                    font-size: 12px;
                    font-weight: 500;
                    border-radius: 10.5px;
                    user-select: none;
                }
            }
        }

        .content {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 10px;

            .address {
                font-size: 14px;
                line-height: 20px;
            }

            .button {
                img {
                    width: 20px;
                    height: 20px;
                }
            }
        }

        .contact {
            display: flex;
            color: rgba(0,0,0,1);
            font-size: 14px;
            line-height: 20px;
            margin-top: 10px;
            padding-top: 10px;
            border-top: solid 1px rgba(221,221,221,1);;

            div {
                width: 50%;
            }
        }

        .note {
            display: flex;
            align-items: baseline;

            .icon {
                flex: 0;
            }

            .content {
                white-space: pre-line;
                color: #9B9B9B;
                font-size: 14px;
                letter-spacing: 0;
                line-height: 20px;
                word-break: break-all;
            }
        }

        .divider {
            width: inherit;
            margin: 10px 10px;
            border-bottom: solid 1px #DDDDDD;
        }

        .price {
            text-align: center;
            color: #9B9B9B;
            font-size: 13px;
            letter-spacing: 0;
            line-height: 18px;
            display: flex;
            justify-content: center;
            align-items: center;

            span {
                color: #339933;
                font-size: 16px;
                font-weight: 500;
                letter-spacing: 0;
                line-height: 22px;
                margin-left: 10px;
            }
        }

        .advanced {
            display: flex;
            justify-content: center;
            align-items: center;
            color: #339933;
            line-height: 20px;
            box-shadow: 0 2px 8px 0 rgba(51,153,51,0.35);
            margin: 10px -10px -20px -10px;
            background-color: #FFFFFF;
            border-radius: 0 0 5px 5px;
            padding: 10px;
            user-select: none;
            cursor: pointer;

            .advanced-item {
                display: flex;
                align-items: center;
                justify-content: center;

                &:not(:last-child) {
                    margin-right: 5px;
                }
            }
        }

        .products {
            margin-top: 10px;

            .product-note {
                display: flex;
                align-items: baseline;
                margin-left: 16px;

                .product-icon {
                    flex: 0;
                }

                .product-content {
                    white-space: pre-line;
                    color: #9B9B9B;
                    font-size: 12px;
                    letter-spacing: 0;
                    line-height: 17px;
                }
            }

            .product {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0 10px;

                .product-price {
                    color: #339933;
                    font-size: 14px;
                    letter-spacing: 0;
                    line-height: 20px;
                }

                .product-content {
                    .product-title {
                        color: #9B9B9B;
                        font-size: 14px;
                        letter-spacing: 0;
                        line-height: 20px;

                        span {
                            color: #339933;
                            font-size: 14px;
                            letter-spacing: 0;
                            line-height: 20px;
                            margin-right: 10px;
                        }
                    }

                    .product-info {
                        color: #9B9B9B;
                        font-size: 12px;
                        letter-spacing: 0;
                        line-height: 17px;
                        margin-top: 5px;

                        span {
                            color: #339933;
                            font-size: 14px;
                            letter-spacing: 0;
                            line-height: 20px;
                            margin-right: 10px;
                        }
                    }
                }
            }
        }
    }
</style>
